<template>
  <div class="c-contentsAddition">
    <div
      class="c-contentsAddition_histories"
      v-if="additionsList.length"
    >
      <div
        class="c-contentsAddition_history"
        v-for="addition in additionsList"
        :key="addition.created"
      >
        <contents-addition-content
          :content="addition.note"
          :time="addition.created"
        />
      </div>
    </div>
    <div
      class="c-contentsAddition_input"
      v-if="isAdditionable"
    >
      <p class="c-contentsAddition_info">
        <coconala-icon
          name="info-circle"
          size="16px"
        />
        <span>依頼内容の追記は{{ MAX_COUNT }}回までです。追記すると、すでにご応募頂いている提案者にお知らせします。</span>
      </p>
      <c-input-v2
        type="textarea"
        :rows="inputRows"
        :minlength="MIN_LENGTH"
        :maxlength="MAX_LENGTH"
        placeholder="追記したい依頼内容を記入してください"
        v-model="inputData"
        @validate="validateInput"
      />
      <c-button-v2
        color="primary-blue"
        size="ms"
        :width="buttonWidth"
        :disabled="!isValidButton"
        @click="addRequestAdditionalNote"
      >
        追記する
      </c-button-v2>
    </div>
    <b-loading
      :is-full-page="false"
      :active.sync="isLoading"
    />
  </div>
</template>
<script>
import ContentsAdditionContent from './ContentsAdditionContent'

import { mapGetters, mapState } from 'vuex'

const MIN_LENGTH = 100
const MAX_LENGTH = 2000
const MAX_COUNT = 3 // 追記できる回数

export default {
  name: 'ContentsAddition',
  components: {
    ContentsAdditionContent
  },
  props: {
    isMyRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MIN_LENGTH,
      MAX_LENGTH,
      MAX_COUNT,
      inputData: '',
      isLoading: false,
      isValid: false
    }
  },
  mounted() {
    this.getRequestAdditionalNotes()
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    ...mapState('pages/requests/request', ['additionsList', 'requestDetail']),
    inputRows() {
      if (this.isPC) {
        return 5
      }
      return 6
    },
    buttonWidth() {
      if (this.isPC) {
        return '120px'
      }
      return '100%'
    },
    isAdditionable() {
      return (
        this.isMyRequest &&
        !this.requestDetail.outline.isExpired &&
        this.additionsList.length < MAX_COUNT
      )
    },
    isValidButton() {
      // フォームが空のときはエラー表示しないが送信はできない
      return this.isValid && this.inputData.length > 0 && !this.isLoading
    }
  },
  methods: {
    async getRequestAdditionalNotes() {
      this.isLoading = true
      await this.$store
        .dispatch('pages/requests/request/getRequestAdditionalNotes', {
          params: { requestId: this.requestDetail.id }
        })
        .catch(() => {
          this.$notify({
            group: 'flash',
            title: '追記の取得に失敗しました',
            type: 'error'
          })
        })
      this.isLoading = false
    },
    async addRequestAdditionalNote() {
      this.isLoading = true
      try {
        await this.$store.dispatch('pages/requests/request/addRequestAdditionalNote', {
          params: {
            requestId: this.requestDetail.id,
            note: this.inputData
          }
        })
        this.inputData = ''
        await this.getRequestAdditionalNotes()
        this.$notify({
          group: 'flash',
          title: '依頼内容を追記し、提案者にお知らせしました',
          type: 'success'
        })
      } catch (grpcCode) {
        this.isLoading = false
        this.$notify({
          group: 'flash',
          title: '処理に失敗しました',
          type: 'error'
        })
      }
    },
    validateInput(isValid) {
      this.isValid = isValid
    }
  }
}
</script>
<style lang="scss" scoped>
.c-contentsAddition {
  position: relative;

  &_history {
    & + & {
      margin-top: 16px;
    }
  }

  &_histories {
    background-color: $color-gray-50;
  }

  &_histories + &_input {
    margin-top: 16px;
  }

  &_input {
    box-sizing: content-box;
    height: 224px;
  }

  &_info {
    color: $color-gray-700;
    font-size: 12px;

    .coconala-icon {
      margin-right: 4px;
    }
  }

  .c-buttonV2 {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-contentsAddition {
    padding: 12px;
    border-top: 1px solid $color-gray-200;
    border-bottom: 1px solid $color-gray-200;

    &_histories {
      padding: 12px;
    }

    &_input {
      height: auto;
    }

    &_info {
      display: flex;

      .coconala-icon {
        margin-top: 2px;
      }
    }

    .c-buttonV2 {
      position: static;
      margin-top: 12px;
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-contentsAddition {
    &_histories {
      padding: 20px;
      border-radius: 3px;
    }
  }
}
</style>
